import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';

import VideoPlayer from './VideoPlayer';
import icDrawerBtn from '../icons/ic-btn-drawer.svg';
import ImageSlider from './ImageSlider';
import {
  insertContentsTimeLog,
  insertItemLog,
  insertMakeShopItemLog,
  insertSlideLog,
} from '../modules/NetworkFunction';
import ProductSlider from './ProductSlider';

function DrawerContents({
  videoUrl,
  slideList,
  btnColor,
  fontColor,
  font,
  btnBorderRadius,
  contentNo,
  detailPath,
  margin,
  shopMode,
}) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [currentSlideIdx, setCurrentSlideIdx] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);
  const [playing, setPlaying] = useState(true);
  const [imageSlider, setImageSlider] = useState();
  const [productSlider, setProductSlider] = useState();

  const timerId = useRef();
  const playerRef = useRef();
  const sliderRef = useRef();

  useEffect(() => {
    timerId.current = setInterval(async () => {
      if (playing) {
        const time = await playerRef.current.getCurrentTime();
        setCurrentTime(Number.parseInt(time));
        if (time !== null && contentNo) {
          const params = `?contentsNo=${contentNo}&time=${time}`;
          insertContentsTimeLog(params);
        }
      }
    }, 1000);

    return () => {
      clearInterval(timerId.current);
    };
  }, [playerRef, playing, timerId, contentNo]);

  useEffect(() => {
    const checkPlayer = () => {
      const time = currentTime;

      for (let i = 0; i < slideList.length; i++) {
        if (slideList[i].displayTime > time) {
          let index = i < 1 ? 0 : i - 1;
          setCurrentSlideIdx(index);
          break;
        } else if (i === slideList.length - 1) {
          setCurrentSlideIdx(i);
        }
      }
    };
    checkPlayer();
  }, [currentTime, slideList]);

  useEffect(() => {
    if (sliderRef.current) {
      sliderRef.current.handleChangeSlideIdx(currentSlideIdx);
    }
  }, [currentSlideIdx]);

  const itemClick = (idx) => {
    _setPage(slideList[idx], idx);
  };

  const _setPage = (slideItem, index) => {
    if (index !== currentSlideIdx) {
      playerRef.current.seekTo(slideItem.displayTime);
      setCurrentSlideIdx(index);
      setPlaying(true);
      if (contentNo) {
        insertSlideLog(`?slideNo=${slideItem.slideNo}`);
      }
    }
  };

  const handleExpand = () => {
    setIsExpanded((prev) => !prev);
  };

  const handleBuyBtnClick = () => {
    if (detailPath) {
      window.open(detailPath + slideList[currentSlideIdx].productNo, '_blank');
      if (shopMode === 'cafe24') {
        insertItemLog(
          `?slideNo=${slideList[currentSlideIdx].slideNo}&itemNo=${slideList[currentSlideIdx].itemNo}`
        );
      } else {
        insertMakeShopItemLog(
          `?slideNo=${slideList[currentSlideIdx].slideNo}&itemNo=${slideList[currentSlideIdx].itemNo}`
        );
      }
    }
  };

  return (
    <DrawerContainer
      isExpanded={isExpanded}
      style={{ margin: `${margin}px auto` }}
    >
      <LeftContainer>
        <VideoContainer>
          <VideoPlayer
            ref={playerRef}
            videoUrl={videoUrl}
            playing={playing}
            setPlaying={setPlaying}
            isMobile={false}
          />
          <div style={{ position: 'absolute', bottom: -6, left: -1.44 }}>
            <img
              src="https://wizmon-bucket.s3.ap-northeast-2.amazonaws.com/icons/ic-rect.png"
              alt="영상 속 다른 상품"
            />
            <div
              style={{
                position: 'absolute',
                top: '50%',
                left: '45%',
                transform: 'translate(-50%, -50%)',
                fontSize: 20,
                fontWeight: 700,
                whiteSpace: 'nowrap',
                fontFamily: font,
              }}
            >
              영상 속 다른 상품
            </div>
          </div>
        </VideoContainer>
        <ItemListContainer>
          <ProductSlider
            slideList={slideList}
            currentSlideIdx={currentSlideIdx}
            itemClick={itemClick}
            btnColor={btnColor}
            fontColor={fontColor}
            font={font}
            setSlider={setProductSlider}
            syncSlider={imageSlider}
          />
        </ItemListContainer>
      </LeftContainer>

      <RightContainer isExpanded={isExpanded}>
        <SlideListContainer>
          {slideList.length > 0 && (
            <ImageSlider
              slideList={slideList}
              ref={sliderRef}
              handleSlideClick={(idx) => {
                _setPage(slideList[idx], idx);
              }}
              setSlider={setImageSlider}
              syncSlider={productSlider}
            />
          )}
        </SlideListContainer>

        <BuyButtonContainer>
          <BuyButton
            borderRadius={btnBorderRadius}
            fontFamily={font}
            fontColor={fontColor}
            btnColor={btnColor}
            onClick={handleBuyBtnClick}
          >
            구매하기
          </BuyButton>
        </BuyButtonContainer>
      </RightContainer>

      <DrawerButton onClick={handleExpand} isExpanded={isExpanded} />
    </DrawerContainer>
  );
}

export default DrawerContents;

const DrawerContainer = styled.div`
  position: relative;
  display: flex;
  height: 480px;
  box-shadow: 0px 0px 11px 0px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  transition: width 0.7s;
  width: ${({ isExpanded }) => (isExpanded ? '90%' : '50%')};
  iframe {
    border-radius: ${({ isExpanded }) =>
      isExpanded ? '5px 0 0 0' : '5px 5px 0'};
  }
`;

const VideoContainer = styled.div`
  height: 75%;
  position: relative;
`;

const LeftContainer = styled.div`
  width: 100%;
  min-width: 0;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
`;

const ItemListContainer = styled.div`
  height: 25%;
  width: 100%;
`;

const RightContainer = styled.div`
  height: 100%;
  overflow: hidden;
  transition: width 0.7s;
  width: ${({ isExpanded }) => (isExpanded ? '100%' : '0')};
`;

const SlideListContainer = styled.div`
  height: 75%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #ebebeb;
`;

const DrawerButton = styled.button`
  background-image: url(${icDrawerBtn});
  width: 50px;
  height: 50px;
  background-color: transparent;
  background-position: center;
  position: absolute;
  top: 50%;
  right: -25px;
  transform: translateY(-50%) ${(props) => props.isExpanded && 'rotate(180deg)'};
  &:hover {
    ::after {
      font-size: 14px;
      color: #ababab;
      white-space: nowrap;
      position: absolute;
      top: 50%;
      right: ${(props) => (props.isExpanded ? '45px' : '-35px')};
      content: ${(props) => (props.isExpanded ? "'닫기'" : "'펼치기'")};
      transform: translateY(-50%)
        ${(props) => props.isExpanded && 'rotate(180deg)'};
    }
  }
`;

const BuyButtonContainer = styled.div`
  height: 25%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px 0px;
`;

const BuyButton = styled.button`
  width: 95%;
  height: 60%;
  border-width: 0;
  font-weight: 700;
  font-size: 15px;
  white-space: nowrap;
  font-family: ${(props) => props.fontFamily} !important;
  background-color: ${(props) => props.btnColor};
  color: ${(props) => props.fontColor};
  border-radius: ${(props) => props.borderRadius}px;
`;
